// extracted by mini-css-extract-plugin
export default {"clickable":"Locations_clickable__J-AJQ","loaderContainer":"Locations_loaderContainer__avqRJ","icon":"Locations_icon__eyG9Z"};